import { create } from "zustand";
import { StripeApi } from "../api/stripeApi";
import { UserApi } from "../api/userApi";
import { UserSubscription } from "../model/userSubscription";

interface SubscriptionActions {
  reloadSubscriptionsInfo: () => Promise<void>;
  navigateToUserPanel: () => Promise<void>;
}
interface SubscriptionState {
  subscription: UserSubscription | null;

  actions: SubscriptionActions;
}

const useSubscriptionStore = create<SubscriptionState>((set) => {
  return {
    subscription: null,
    tokensBalance: 0,

    actions: {
      reloadSubscriptionsInfo: async () => {
        const subscription = await UserApi.loadUserSubscription();

        set({
          subscription,
        });
      },

      navigateToUserPanel: async () => {
        const url = await StripeApi.loadUserPanelUrl();
        window.location.href = url;
      },
    },
  };
});

export const useUserSubscription = () =>
  useSubscriptionStore((state) => state.subscription);

export const useSubscriptionActions = () =>
  useSubscriptionStore((state) => state.actions);
